
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonPulldown from '@/components/molecules/ButtonPulldown.vue'
import { GradeCode } from '@/const/GradeCode'

/**
 * 学年選択ボタン
 */
@Component({
  components: {
    ButtonPulldown,
  },
})
export default class GradeSelectButton extends Vue {
  /** 選択中の学年 */
  @Prop()
  private gradeMaster!: GradeCode.GradeMaster

  /**
   * ボタンのボーダー色と文字色を設定する
   *
   * @returns css：カラー変数文字列
   */
  private get setStyle(): { [key: string]: string } {
    const style = this.gradeMaster.color
    return {
      '--grade-color': `var(${style})`,
    }
  }

  /**
   * ボタンのラベル
   *
   * @returns 学年コードのラベル
   */
  private get label(): string {
    return this.gradeMaster.label
  }

  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
